// A slow, endless row of YouTube channels (home, sign-up, product pages).
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import aquinas_yt from '../../assets/images/YT/quin-yt.jpg';
import corbin_brown_yt from '../../assets/images/YT/cbrown-yt.jpg';
import rotten_mango_yt from '../../assets/images/YT/rotten-mango-yt.jpg';
import come_and_talk_yt from '../../assets/images/YT/come-and-talk-yt.jpg';
import valuetainment_yt from '../../assets/images/YT/valuetainment-yt.jpg';
import espn_yt from '../../assets/images/YT/espn-yt.jpg';
import chris_will_yt from '../../assets/images/YT/chris-will-yt.jpg';
import nba_yt from '../../assets/images/YT/nba-yt.jpg';
import first_feast_yt from '../../assets/images/YT/first-we-feast-yt.jpg';
import uc_berkeley_yt from '../../assets/images/YT/uc-berk-yt.jpg';
import wired_yt from '../../assets/images/YT/wired-yt.jpg';
import jubilee_yt from '../../assets/images/YT/jubilee-yt.jpg';
import './channelMarquee.css';

const CHANNELS = [
  { img: espn_yt, name: 'ESPN', subscribers: '13.4M' },
  { img: rotten_mango_yt, name: 'Rotten Mango', subscribers: '2.8M' },
  { img: corbin_brown_yt, name: 'Corbin Brown', subscribers: '100K' },
  { img: come_and_talk_yt, name: 'Come And Talk 2 Me', subscribers: '592K' },
  { img: nba_yt, name: 'NBA', subscribers: '22.8M' },
  { img: uc_berkeley_yt, name: 'UC Berkeley', subscribers: '66K' },
  { img: wired_yt, name: 'WIRED', subscribers: '12M' },
  { img: jubilee_yt, name: 'Jubilee', subscribers: '9.8M' },
  { img: first_feast_yt, name: 'First We Feast', subscribers: '14.5M' },
  { img: aquinas_yt, name: 'Pints With Aquinas', subscribers: '546K' },
  { img: chris_will_yt, name: 'Chris Williamson', subscribers: '3.4M' },
  { img: valuetainment_yt, name: 'Valuetainment', subscribers: '5.6M' },
];

export default function ChannelMarquee({ caption }) {
  return (
    <div className="mkm">
      {caption && <p className="mkm-caption">{caption}</p>}
      <div className="mkm-viewport">
        {/* two copies side by side; the track slides one copy's width and loops seamlessly */}
        <div className="mkm-track">
          {[0, 1].map(copy => (
            <ul key={copy} className="mkm-list" aria-hidden={copy === 1 ? 'true' : undefined}>
              {CHANNELS.map(c => (
                <li key={c.name} className="mkm-channel">
                  <span className="mkm-avatar">
                    <img src={c.img} alt="" width="44" height="44" />
                    <FontAwesomeIcon icon={faYoutube} className="mkm-yt" />
                  </span>
                  <span>
                    <span className="mkm-name">{c.name}</span>
                    <span className="mkm-subs">{c.subscribers} subscribers</span>
                  </span>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
}
